import { createSlice } from "@reduxjs/toolkit";

const VariousVariables = createSlice({
  name: "VariousVariables",
  initialState: {
    refreshTable: {
      WorkExperience: false,
      table2: false,
      VoluntaryCommunityWork: false,
      DetailsOfResearchSubmitted: false,
      tableTask: false,
      EvaluatorInfo: false,
      ScientificCommittee: false,
      EvaluatorTransfer: false,
      ScientificCommitteeRequsetTable: false,
      TasksByEvalutor: false,
      SelectedTable: false,
      subTaskScientific:false,
    },
    refreshApplicationInformation: false,
    PageName: "",
  },
  reducers: {
    setRefreshTable: (state, action) => {
      const { tableId } = action.payload;
      state.refreshTable[tableId] = !state.refreshTable[tableId];
    },
    setrefreshApplicationInformation: (state) => {
      if (state.refreshApplicationInformation) {
        state.refreshApplicationInformation = false;
      } else {
        state.refreshApplicationInformation = true;
      }
    },
    setPageName: (state, action) => {
      state.PageName = action.payload;
    },
  },
});

export const {
  setRefreshTable,
  setrefreshApplicationInformation,
  setPageName,
} = VariousVariables.actions;
export default VariousVariables.reducer;
